import { Container } from '@mui/material';
import React, { useContext } from 'react';
import { ThemeContext } from '../../../contexts/theme-context';
import { workData } from '../../../data/workData';
import './workstyle.css';

function Workstyle() {
  const { theme } = useContext(ThemeContext);

  return (
    <div style={{ backgroundColor: theme.secondary }}>
      <Container className='workstyle' id='experience'>
        <h1 style={{ color: theme.primary }}>{workData.title}</h1>

        <div className='workstyle-grid'>
          <section className='workstyle-card' style={{ background: theme.quaternary }}>
            <h2 style={{ color: theme.primary }}>How I build</h2>
            <ul>
              {workData.workStyle.map((item) => (
                <li key={item} style={{ color: theme.tertiary }}>
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section className='workstyle-card' style={{ background: theme.quaternary }}>
            <h2 style={{ color: theme.primary }}>Current goals</h2>
            <ul>
              {workData.goals.map((goal) => (
                <li key={goal} style={{ color: theme.tertiary }}>
                  {goal}
                </li>
              ))}
            </ul>
          </section>
        </div>
      </Container>
    </div>
  );
}

export default Workstyle;
